import React from 'react';
import DOMPurify from 'dompurify';
import '../styles/ProjectSM.css'
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import KranIcon from '../website_images/Icons/kran.png'
import HausIcon from '../website_images/Icons/haus.png'
import GrundrissIcon from '../website_images/Icons/grundriss.png'
import ParkenIcon from '../website_images/Icons/parken.png'
import '../styles/ProjectKO.css'
import ScrollAnimation from '../components/ScrollAnimation';

const ProjectKO: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="container projects">
            <section className="projects-ko-header page-hero" id="page-hero" />
            <section className="main-section fullbleed">
                <ScrollAnimation animation="fadeInUp" delay={0.1}>
                    <div id="team">
                        <h2>{t('projectKOHeader')}</h2>
                        <h1>{t('projectKOTitle')}</h1>
                        <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('projectKODescription')) }}>
                        </p>
                    </div>
                </ScrollAnimation>
            </section>

            <section className="section-investmentProducts fullbleed">
                <div className="company-inner">
                    <ScrollAnimation animation="fadeInUp" delay={0.1}>
                        <div className="projectsm-slider-section" id="brand">
                            <div className='slider-subsection'>
                                <div className='icon-title'>
                                    <img src={KranIcon} alt="Kran icon" className='icons' />
                                    <h2>{t('constructionStart')}</h2>
                                </div>
                                <span>{t('constructionStartDateKO')}</span>
                            </div>
                            <div className='slider-subsection'>
                                <div className='icon-title'>
                                    <img src={HausIcon} alt="Haus icon" className='icons' />
                                    <h2>{t('completion')}</h2>
                                </div>
                                <span>{t('completionDateKO')}</span>
                            </div>
                            <div className='slider-subsection'>
                                <div className='icon-title'>
                                    <img src={GrundrissIcon} alt="Grundriss icon" className='icons' />
                                    <h2>{t('residentialUnits')}</h2>
                                </div>
                                <span>{t('residentialUnitsDetailsKO')}</span>
                            </div>
                            <div className='slider-subsection'>
                                <div className='icon-title'>
                                    <img src={ParkenIcon} alt="Parken icon" className='icons' />
                                    <h2>{t('parkingSpaces')}</h2>
                                </div>
                                <span>{t('parkingSpacesDetailsKO')}</span>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            </section>

            <section className="main-section">
                <ScrollAnimation animation="fadeInUp" delay={0.1}>
                    <div className='projectsm-highlights'>
                        <h1>{t('projectHighlights')}</h1>
                        <ul>
                            <li>{t('projectHighlightKO1')}</li>
                            <li>{t('projectHighlightKO2')}</li>
                            <li>{t('projectHighlightKO3')}</li>
                            <li>{t('projectHighlightKO4')}</li>
                        </ul>
                    </div>
                </ScrollAnimation>
            </section>

            {/**  <section className="section-investmentProducts fullbleed">
                <div className="company-inner">
                    <div className='projecttu-section'>
                        <h1>{t('integratedRealEstateKnowhow')}</h1>
                        <h2>{t('strongGroupSystem')}</h2>
                        <p>{t('integratedRealEstateDescription')}</p>
                    </div>

                    <div className="contact-button-section company-contact">
                        <Link to='/unternehmen' className="contact-button">
                            {t('discoverCompanies')}
                        </Link>
                    </div>
                </div>
            </section>*/}
            <section className="main-section fullbleed">
                <ScrollAnimation animation="fadeInUp" delay={0.1}>
                    <div>
                        <h1>{t('projectInterestTitle')}</h1>
                        <h2>{t('projectInterestDescription')}</h2>
                        <div className="contact-button-section">
                            <Link to='/kontakt' className="knowhow-button-section projecttu-button">{t('requestProjectProfile')}</Link>
                        </div>
                    </div>
                </ScrollAnimation>
            </section>
        </div>
    );
};

export default ProjectKO;
